import React from 'react';
import { useUpdateMachine } from './presenter';
import { MachineUpdateView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  id: string;
  navigate: (r: Route) => void;
};

const MachineUpdatePage: React.FC<Props> = ({ id, navigate }) => {
  const vm = useUpdateMachine(id, () => navigate({ name: 'machines/index' }));
  const confirm = useConfirm();
  const toast = useToast();
  return (
    <MachineUpdateView
      form={vm.form}
      setField={vm.setField as any}
      onSubmit={async () => {
        const ok = await confirm({ title: 'Update Machine', message: 'Apply these changes?', confirmText: 'Update' });
        if (!ok) return;
        await vm.submit();
        toast.success('Machine updated');
      }}
      onCancel={() => navigate({ name: 'machines/index' })}
      loading={vm.loading}
      error={vm.error}
    />
  );
};

export default MachineUpdatePage;
